import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { modalState } from '@/state/modal.state';
import { Modal } from '@/ui/modal/modal';
import { useApproveProjectRequest } from '@/features/projects/hooks/use-approve-project-request.mutation';
import { useAtomValue, useSetAtom } from 'jotai';

export const ApproveProjectRequestModal = () => {
  const modal = useAtomValue(modalState);
  const setModal = useSetAtom(modalState);
  const { t } = useTranslation('request-project');
  const approveMutation = useApproveProjectRequest();

  if (!modal || modal.state !== 'approveProjectRequest') return null;

  const close = () => {
    setModal(null);
  };

  const handleApproveRequest = () => {
    approveMutation.mutate(modal.requestId, {
      onSuccess: () => {
        close();
      },
    });
  };

  return (
    <Modal
      header={t`approveModal.title`}
      onClose={close}
      mainAction={{
        label: t`approveModal.confirm`,
        onClick: handleApproveRequest,
      }}
      secondaryAction={{
        label: t`default:cancel`,
        onClick: close,
      }}
      loading={approveMutation.isPending}
      disabled={approveMutation.isPending}
      variant="info"
    >
      <Container>
        <Description>{t`approveModal.description`}</Description>
      </Container>
    </Modal>
  );
};

const Container = styled('div')`
  height: 100px;
`;

const Description = styled('div')`
  color: ${({ theme }) => theme.colors.gray.c12};
  font-family: ${({ theme }) => theme.fonts.neue};
  font-size: 14px;
  line-height: 145%;
  letter-spacing: 0.03em;
`;
